import React from 'react';
import { CheckCircle2, Sparkles } from 'lucide-react';
import { motion } from 'framer-motion';
const items = [{
  title: 'Programa Completo de Reiki Terapéutico - Nivel I',
  description: 'Aprendé a canalizar energía, trabajar chakras y aplicar Reiki con seguridad desde el primer día.',
  image: 'https://cdn.magicpatterns.com/uploads/uD4E2oPGABzkd1H3DF7Lnr/Diseno_sin_titulo_(1).png'
}, {
  title: 'Programa Completo de Reiki Terapéutico - Nivel II',
  description: 'Activá técnicas avanzadas para tratar a otros, incluso sin contacto físico.',
  image: 'https://cdn.magicpatterns.com/uploads/vYMEPi1e4R8XGBnEaogjFq/Diseno_sin_titulo_(2).png'
}, {
  title: 'Programa Completo de Reiki Terapéutico - Nivel III',
  description: 'Elevá tu práctica al siguiente nivel y aprendé a realizar sintonizaciones con confianza.',
  image: 'https://cdn.magicpatterns.com/uploads/ib1zaX7hpqwQD8aApKS6ag/Diseno_sin_titulo_(3).png'
}, {
  title: 'Kit de Formularios, Mapas y Guías de Post-Sesión',
  description: 'Incluye formularios, guías y estructuras listas para atender clientes con claridad y orden.',
  image: 'https://cdn.magicpatterns.com/uploads/mjAhyK75UqDUM3iivGvrct/Diseno_sin_titulo_(1).png'
}, {
  title: 'Fichas de Anamnesis Editables (2modelos - Canva)',
  description: 'Personalizá tus sesiones con materiales profesionales sin perder tiempo creando desde cero.',
  image: 'https://cdn.magicpatterns.com/uploads/5JARbecTesETT8GofpP41H/Diseno_sin_titulo_(1).png'
}, {
  title: 'Diario de Práctica y Expansión Reiki',
  description: 'Registrá avances, resultados y progreso en cada sesión para mejorar tu práctica.',
  image: 'https://cdn.magicpatterns.com/uploads/e8RMQ8M4J8F45m72Mq5rsA/Diseno_sin_titulo_(1).png'
}, {
  title: 'Tarjetas Visuales + Mapa de Chakras',
  description: 'Tarjetas, mapas y guías para consultar en segundos durante tus sesiones.',
  image: 'https://cdn.magicpatterns.com/uploads/prVsYuVM2VcGEdLSN5XXHP/Diseno_sin_titulo_(1).png'
}, {
  title: 'Proceso guiado de integración energética (21 días)',
  description: 'Fortalecé tu conexión con Reiki paso a paso después de cada activación.',
  image: 'https://cdn.magicpatterns.com/uploads/4bWEBtWM9JVit5uQays1c4/Diseno_sin_titulo_(1).png'
}, {
  title: 'Sistema de Seguimiento de Clientes',
  description: 'Llevá control de sesiones, notas y evolución para brindar una experiencia profesional.',
  image: 'https://cdn.magicpatterns.com/uploads/kdJ57U6epdx8hPJpib2KZp/Diseno_sin_titulo_(1).png'
}];
export function WhatYouReceive() {
  return <section className="py-24 bg-white relative overflow-hidden pt-[30px] pb-[30px]" data-id="element-369">
      {/* Background Decorative Elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-violet-50 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 pointer-events-none opacity-50" data-id="element-370" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-pink-50 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2 pointer-events-none opacity-50" data-id="element-371" />

      <div className="max-w-5xl mx-auto px-4 relative z-10" data-id="element-372">
        <div className="text-center mb-16" data-id="element-373">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-violet-100 text-violet-600 text-xs font-black uppercase tracking-widest mb-6" data-id="element-374">
            <Sparkles size={14} data-id="element-375" />
            <span data-id="element-376">Tu Transformación Profesional</span>
          </motion.div>

          <h2 className="md:text-6xl text-violet-950 text-[32px] font-medium font-['Playfair_Display']" data-id="element-377">
            Aquí está todo lo que recibís <br className="hidden md:block" data-id="element-378" />
            <span className="text-violet-600 italic" data-id="element-379">al acceder hoy</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-380">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group p-6 rounded-3xl bg-violet-50/50 border border-violet-100 hover:bg-white hover:shadow-xl hover:shadow-violet-200/30 transition-all duration-300" data-id="element-381">
              {item.image && <div className="mb-6 overflow-hidden rounded-2xl" data-id="element-382">
                  <img src={item.image} alt={item.title} className="w-full h-auto object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-383" />
                </div>}
              <div className="flex items-start gap-4" data-id="element-384">
                <div className="shrink-0 mt-1" data-id="element-385">
                  <CheckCircle2 className="text-violet-600 group-hover:scale-110 transition-transform" size={24} data-id="element-386" />
                </div>
                <div data-id="element-387">
                  <h3 className="text-lg font-bold text-violet-950 mb-2 leading-tight" data-id="element-388">
                    {item.title}
                  </h3>
                  <p className="text-violet-800/70 text-sm leading-relaxed" data-id="element-389">
                    {item.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-16 p-8 rounded-[2.5rem] bg-gradient-to-br from-violet-600 to-purple-700 text-white text-center shadow-2xl shadow-violet-200" data-id="element-390">
          <p className="text-xl md:text-2xl font-medium italic" data-id="element-391">
            "No es solo una guía, es el sistema operativo de tu nueva vida como
            terapeuta profesional."
          </p>
        </div>
      </div>
    </section>;
}